import { useEffect, useState } from 'react';
import { Search } from '@library/components/inputs';
import { cn } from '@library/component-utils/cn';
import searchIconURL from '@library/assets/images/Search.png';
import { useDebounceFn } from '@library/hooks/useDebounce';

export interface SearchbarProps {
  className?: string;
  disabled?: boolean;
  handleSearch: (value: string) => void;
  id?: string;
  placeholder?: string;
  searchClassName?: string;
  searchValue?: string;
}

export const Searchbar = ({
  className = '',
  disabled = false,
  handleSearch,
  id = 'projection-search',
  placeholder = undefined,
  searchClassName = 'placeholder:text-soClean-180',
  searchValue = ''
}: SearchbarProps) => {
  const [searchBarValue, setSearchBarValue] = useState(searchValue);
  const { debounce: debouncedHandleSearch } = useDebounceFn(
    handleSearch as (...args: unknown[]) => void,
    500
  );

  const handleOnValueChange = (value: string) => {
    setSearchBarValue(value);
    debouncedHandleSearch(value);
  };

  useEffect(() => {
    setSearchBarValue(searchValue);
  }, [searchValue]);

  return (
    <div
      className={cn(
        'border-soFresh-140 flex h-11 w-full min-w-min rounded-md border py-1.5 text-sm sm:leading-6',
        disabled ? 'bg-soFresh-130' : 'bg-soFresh-110',
        className
      )}
    >
      <div className="pointer-events-none inset-y-0 left-0 flex items-center pl-3">
        <img src={searchIconURL} alt="search" />
      </div>
      <Search
        className={cn(
          'text-soClean-140 placeholder:text-soClean-140 w-full rounded-md border-0 bg-transparent py-1.5 text-sm hover:ring-0 focus:ring-0 sm:leading-6',
          searchClassName
        )}
        disabled={disabled}
        id={id}
        data-testid={id}
        onValueChange={handleOnValueChange}
        placeholder={placeholder}
        value={searchBarValue}
      />
    </div>
  );
};
